import { BALANCE } from '../balance';
import type { MiniGameDefInput } from '../schemas/minigames';

/**
 * Lau bụi (minigames.md §2.5), Xếp thùng hàng (§3.3) and Bếp của bà (§4.5). Packing puzzles are generated in game
 * code; cooking recipes (steps, ingredients) live in game/minigames/cooking/recipes.ts.
 */
export const MINI_GAMES = [
  {
    id: 'mg_dusting',
    nameKey: 'minigame.mg_dusting.name',
    durationHintSec: 60,
    repeatReward: BALANCE.miniGameRepeatReward,
    repeatScoreFull: 0.92,
    repeatCooldownSec: BALANCE.miniGameCooldownSec,
    levels: [
      {
        level: 1,
        nameKey: 'minigame.mg_dusting.level_1',
        passScore: 0.7,
        firstClear: [
          { type: 'stars', amount: BALANCE.starsPer.miniGameLevel },
          { type: 'coins', amount: 20 },
        ],
        noteKeys: [
          'minigame.mg_dusting.note_l1_1',
          'minigame.mg_dusting.note_l1_2',
          'minigame.mg_dusting.note_l1_3',
        ],
        params: { object: 'box', completeAt: 0.92, tutorialCompleteAt: 0.85, sticky: 0, cobwebs: 1 },
      },
      {
        level: 2,
        nameKey: 'minigame.mg_dusting.level_2',
        passScore: 0.7,
        firstClear: [
          { type: 'stars', amount: BALANCE.starsPer.miniGameLevel },
          { type: 'item', itemId: 'dec_book_stack', qty: 1 },
        ],
        noteKeys: [
          'minigame.mg_dusting.note_l2_1',
          'minigame.mg_dusting.note_l2_2',
          'minigame.mg_dusting.note_l2_3',
        ],
        params: { object: 'frame', completeAt: 0.92, sticky: 2, cobwebs: 0 },
      },
      {
        level: 3,
        nameKey: 'minigame.mg_dusting.level_3',
        passScore: 0.7,
        firstClear: [
          { type: 'stars', amount: BALANCE.starsPer.miniGameLevel },
          { type: 'coins', amount: 60 },
        ],
        noteKeys: [
          'minigame.mg_dusting.note_l3_1',
          'minigame.mg_dusting.note_l3_2',
          'minigame.mg_dusting.note_l3_3',
        ],
        params: { object: 'chest', completeAt: 0.92, sticky: 3, cobwebs: 3 },
      },
    ],
  },
  {
    id: 'mg_packing',
    nameKey: 'minigame.mg_packing.name',
    durationHintSec: 90,
    repeatReward: BALANCE.miniGameRepeatReward,
    repeatScoreFull: 1,
    repeatCooldownSec: BALANCE.miniGameCooldownSec,
    levels: [1, 2, 3].map((level) => ({
      level,
      nameKey: `minigame.mg_packing.level_${String(level)}`,
      passScore: 0.7,
      firstClear: [
        { type: 'stars', amount: BALANCE.starsPer.miniGameLevel },
        { type: 'coins', amount: 20 * level },
      ],
      noteKeys: [1, 2, 3].map((n) => `minigame.mg_packing.note_l${String(level)}_${String(n)}`),
      params: {},
    })),
  },
  {
    id: 'mg_cooking',
    nameKey: 'minigame.mg_cooking.name',
    durationHintSec: 75,
    repeatReward: BALANCE.miniGameRepeatReward,
    repeatScoreFull: BALANCE.cooking.repeatScoreFull,
    repeatCooldownSec: BALANCE.miniGameCooldownSec,
    repeatBonusCooldownSec: BALANCE.cooking.homemadeCooldownSec,
    levels: (
      [
        [1, 'jam', 'prod_home_jam', [{ type: 'item', itemId: 'dec_jam_jars', qty: 1 }]],
        [2, 'noodle', 'prod_home_noodle', [{ type: 'coins', amount: 40 }]],
        [3, 'kimbap', 'prod_home_kimbap', [{ type: 'coins', amount: 60 }]],
      ] as const
    ).map(([level, recipe, dish, extra]) => ({
      level,
      nameKey: `minigame.mg_cooking.level_${String(level)}`,
      passScore: 0.7,
      firstClear: [
        { type: 'stars', amount: BALANCE.starsPer.miniGameLevel },
        ...extra,
        { type: 'item', itemId: dish, qty: 2 },
      ],
      noteKeys: [1, 2, 3].map((n) => `minigame.mg_cooking.note_l${String(level)}_${String(n)}`),
      params: { recipe },
      repeatBonus: [{ type: 'item', itemId: dish, qty: 1 }],
    })),
  },
] as const satisfies readonly MiniGameDefInput[];
